module.exports = __webpack_public_path__ + "img/wl_prod1_3.c32723d2.jpg";